import{usePostHog}from"../../components/PostHogProvider";export default usePostHog;